// The target dev branch references this module from several screens, but the
// branch must use the real authentication flow for QA. Keep the bypass
// disabled unless an explicit implementation is added and reviewed.
export const devLoginBypassEnabled = false;

export const shouldLoadLiveSalonBootstrap = () => true;

export const devBypassUser = null;
export const devBypassActivePlan = "";
export const devBypassModules = [];
